import script from "./BottomNavBar.vue?vue&type=script&setup=true&lang=js"
export * from "./BottomNavBar.vue?vue&type=script&setup=true&lang=js"

import "./BottomNavBar.vue?vue&type=style&index=0&id=10d361a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10d361a0"]])

export default __exports__